import { INews } from "../types/news-type.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getNews = async (exchId: string, token: string) => {
  const response: INews = await request({
    method: "POST",
    url: API_PATHS.news,
    data: {
      token: +token,
      exchId: +exchId,
      offset: 1,
      limit: 10,
    },
  });
  return response;
};
